<template>
  <div class="table-wrap">
    <div class="filter-title">
      <div style="flex: 1; font-weight: bold">
        <el-page-header
          style="line-height: 32px"
          @back="goBack"
          :content="fieldParams.title"
        >
        </el-page-header>
      </div>
      <el-date-picker
        v-model="date"
        type="daterange"
        align="right"
        unlink-panels
        value-format="yyyyMMdd"
        range-separator="至"
        start-placeholder="开始日期"
        end-placeholder="结束日期"
        :picker-options="pickerOptions"
        style="width: 320px; margin: 0 20px"
      ></el-date-picker>
      <el-button type="primary" class="search-btn" @click="handlerSearch"
        >查询</el-button
      >
    </div>
    <div class="content">
      <el-table
        v-if="pageData.total > 0"
        id="rebateSetTable"
        v-loading="loading"
        :data="tableData"
        style="width: 100%"
        height="100%"
      >
        <div v-if="fieldParams.key === 'budgetRoi'">
          <el-table-column
            label="日期"
            prop="installDay"
            fixed="left"
            width="100"
          >
          </el-table-column>
          <el-table-column label="推广总计($)" prop="cost"></el-table-column>
          <el-table-column label="变现收入($)" prop="income"> </el-table-column>
          <el-table-column label="当前ROI" prop="roi"> </el-table-column>
        </div>
        <div v-else>
          <el-table-column
            label="日期"
            prop="installDay"
            :key="Math.random()"
            fixed="left"
            width="100"
          >
          </el-table-column>
          <el-table-column
            v-for="(item, index) in tableHeadList"
            :key="index"
            :label="item"
            :prop="item"
            min-width="100"
          >
            <template slot-scope="scope">
              <span v-if="scope.row.installList">
                {{ scope.row.installList[index] }}</span
              >
              <span v-else-if="scope.row.costList">
                {{ scope.row.costList[index] }}</span
              >
              <span v-else-if="scope.row.purchaseIncomeList">
                {{ scope.row.purchaseIncomeList[index] }}</span
              >
              <span v-else-if="scope.row.arpuList">
                {{ scope.row.arpuList[index] }}</span
              >
              <span v-else> {{ scope.row.incomeList[index] }}</span>
            </template>
          </el-table-column>
        </div>
      </el-table>

      <div v-else>
        <el-empty style="margin-top: 20px" description="暂无数据"></el-empty>
      </div>
    </div>
    <self-pagination
      v-if="pageData.total > 0"
      class="footer-page"
      :total="pageData.total"
      :pageSize="pageData.size"
      :currentPage="pageData.page"
      ref="tabelPagination"
      @getCurrentPage="changePage"
      @handleSizeChange="changePageSize"
    ></self-pagination>
  </div>
</template>

<script>
import {
  getRoiTrendReport,
  getInstallTrendTable,
  getCostTrendTable,
  getIncomeTrendTable,
  getPurchaseIncomeTable,
  getArpuTable,
} from "@/api/bi-board";

export default {
  props: {
    formSearch: Object,
    fieldParams: Object,
  },

  data() {
    return {
      date: [],
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() > Date.now() - 3600 * 1000 * 24 * 2;
        },
      },
      tableHeadList: [],
      tableData: [],
      loading: false,
      pageData: {
        total: 10,
        size: 20,
        page: 1,
      },
    };
  },

  computed: {},

  created() {
    this.date = this.formSearch.formdate;
    this.getList();
  },

  methods: {
    goBack() {
      this.$emit("goBack");
    },
    changePage(page) {
      this.pageData.page = page;
      this.getList();
    },
    changePageSize(size) {
      this.pageData.page = 1;
      this.pageData.size = size;
      this.getList();
    },
    getList() {
      this.loading = true;
      let api = null;
      // 收支-当前ROI
      if (this.fieldParams.key === "budgetRoi") {
        api = getRoiTrendReport;
        // 支出趋势
      } else if (
        ["productOutlay", "countryOutlay", "channelOutlay"].includes(
          this.fieldParams.key
        )
      ) {
        api = getCostTrendTable;
        // 收入趋势
      } else if (
        ["productIncome", "countryIncome", "channelIncome"].includes(
          this.fieldParams.key
        )
      ) {
        api = getIncomeTrendTable;
      } // 内购收入趋势
      else if (
        ["countryPurchaseIncome", "productPurchaseIncome"].includes(
          this.fieldParams.key
        )
      ) {
        api = getPurchaseIncomeTable;
        // Arpu
      } else if (
        ["countryPurchaseArpu", "countryAdArpu"].includes(this.fieldParams.key)
      ) {
        api = getArpuTable;
        // 新增趋势
      } else {
        // 新增趋势
        api = getInstallTrendTable;
      }
      const { afid, platform, geo, team, mediaList, accountGroupCodes } =
        this.formSearch;
      let params = {
        geo: geo.join(",") || null,
        afid: afid.join(",") || null,
        team: team.join(",") || null,
        platform,
        mediaList,
        dateStart: this.date[0],
        dateEnd: this.date[1],
        page: this.pageData.page,
        size: this.pageData.size,
        dimension: this.fieldParams.key.includes("product")
          ? 1
          : this.fieldParams.key.includes("country")
          ? 2
          : 3,
        accountGroupCodes: accountGroupCodes ? [accountGroupCodes] : undefined,
      };
      if (
        ["countryPurchaseArpu", "countryAdArpu"].includes(this.fieldParams.key)
      ) {
        params.type = this.fieldParams.key === "countryPurchaseArpu" ? 2 : 1;
      }
      api(params)
        .then((res) => {
          this.tableHeadList = res.data.tableHeadList;
          this.tableData = res.data.roiTrendList || res.data.dataTrendList;
          this.pageData.total = res.data.count;
          this.loading = false;
        })
        .catch(() => {
          this.loading = false;
        });
    },
    handlerSearch() {
      this.pageData.page = 1;
      this.getList();
    },
  },
};
</script>

<style lang="less" scoped>
.table-wrap {
  height: 100vh;
  .filter-title {
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
    display: flex;
    .title-text {
      color: rgba(0, 0, 0, 0.85);
      font-weight: bold;
      font-size: 16px;
      flex: 1;
    }
  }
  .content {
    height: calc(100% - 260px);
    margin-top: 16px;
    border-radius: 4px;
    background: rgba(255, 255, 255, 1);
    box-shadow: 0px 2px 12px rgba(0, 0, 0, 0.12);
    padding: 16px 24px;
  }
}
</style>
